import { Checkbox, FormControlLabel } from "@mui/material"
import type { ChangeEvent, FC } from "react"
import { memo, useCallback } from "react"
import { useFieldArray } from "react-hook-form"

import type { User } from "@/graphql/codegen/graphql"

export const AccountManagerCheckbox: FC<{
  manager: User
  control: any
  name: string
  onFilterChange: (value: string[]) => void
  accountManagersValue: string[]
  className?: string
}> = memo(({ manager, control, name, onFilterChange, accountManagersValue, className }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  })

  const isChecked = accountManagersValue.includes(manager.userId)

  const handleCheckboxChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.checked) {
        append(manager.userId)
        onFilterChange([...accountManagersValue, manager.userId])
      } else {
        const indexToRemove = fields.findIndex((field) => field.userId === manager.userId)
        remove(indexToRemove)
        onFilterChange(accountManagersValue.filter((v) => v !== manager.userId))
      }
    },
    [append, remove, fields, accountManagersValue, manager.userId, onFilterChange]
  )

  return (
    <FormControlLabel
      control={<Checkbox checked={isChecked} onChange={handleCheckboxChange} />}
      label={manager.name}
      className={`${className} w-full text-ellipsis`}
    />
  )
})
